import { Badge, Button, Radio } from "antd";
import React from "react";
import BottomSheet from "../../../../components/BottomSheet";
import { ServiceState, ServiceType } from "./filters.types";
import "./filterArchive.style.scss";
import { useState } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useEffect } from "react";

const FilterArchive = ({ filters, setfilters }) => {
  const [showBottomSheet, setShowBottomSheet] = useState(false);
  // const [filters, setfilters] = useState({});
  // localStorage
  useEffect(() => {
    let presistedFilters = localStorage.getItem("archive_filter");
    presistedFilters = JSON.parse(presistedFilters);

    if (presistedFilters) {
      setfilters(presistedFilters);
    } else {
      setfilters({
        sort: "DESC",
        sortKey: "updatedAt",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setFiltersToLS = (items) => {
    localStorage.setItem("archive_filter", JSON.stringify(items));
  };

  //
  const changeService = (key, event) => {
    if (event === "show_all") {
      const temp = { ...filters };
      delete temp?.[key];
      setfilters(temp);
      setFiltersToLS(temp);
    } else {
      setfilters((prev) => {
        const newValues = { ...prev, [key]: event };
        setFiltersToLS(newValues);

        return newValues;
      });
    }
  };

  const closeModal = () => {
    setShowBottomSheet(false);
  };

  // useEffect(() => {
  //   setfilters({
  //     sort: "DESC",
  //     sortKey: "updatedAt",
  //   });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <div>
      <Button
        onClick={() =>
          setfilters((prev) => {
            const newFilters = {
              ...prev,
              sort: prev?.sort === "ASC" ? "DESC" : "ASC",
            };
            setFiltersToLS(newFilters);

            return newFilters;
          })
        }
        shape="circle"
      >
        {filters?.sort === "ASC" ? <UpOutlined /> : <DownOutlined />}
      </Button>
      <Badge
        dot={filters?.type || filters?.status}
        offset={[54, 6]}
        color={"#242b3e"}
        size={"default"}
        style={{
          width: 10,
          height: 10,
        }}
      >
        <Button
          onClick={() => setShowBottomSheet(true)}
          shape="round"
          style={{
            marginRight: 5,
          }}
        >
          فیلتر
        </Button>
      </Badge>

      <BottomSheet
        viewerClassName="archive-filter-bg"
        setClose={closeModal}
        isOpen={showBottomSheet}
      >
        <div className="archive-radio-body">
          <h3>نوع خدمت</h3>
          <div className="archive-radio-group">
            <Radio.Group
              name="radiogroup"
              value={filters?.type || "show_all"}
              defaultValue={filters?.type || "show_all"}
              onChange={(event) => changeService("type", event.target.value)}
            >
              {ServiceType.map((item) => {
                return (
                  <Radio className="archive-radio-item" value={item.key}>
                    {item.value}
                  </Radio>
                );
              })}
            </Radio.Group>
          </div>
          <h3>وضعیت خدمت</h3>
          <div className="archive-radio-group">
            <Radio.Group
              name="radiogroup"
              value={filters?.status || "show_all"}
              defaultValue={filters?.status || "show_all"}
              onChange={(event) => changeService("status", event.target.value)}
            >
              {ServiceState.map((item) => {
                return (
                  <Radio className="archive-radio-item" value={item.key}>
                    {item.value}
                  </Radio>
                );
              })}
            </Radio.Group>
          </div>
        </div>
      </BottomSheet>
    </div>
  );
};

export default FilterArchive;
